import React from 'react';
import Menu from './Menu';
import Navbar from './Navbar';
import { Outlet } from 'react-router-dom';

const Main = () => {
  return (
    <div className='flex h-screen'>
      {/* Fixed Menu on the left */}
      <div className='  '>
        <Menu />
      </div>
      {/* Main Content Area */}
      <div className='flex-1 flex flex-col'>
        <Navbar />
        <div className='md:ml-64 lg:ml-64 xl:ml-64' >
        <div className='flex-1 mt-16  w-full scrollbar-custom'>
          <Outlet />
        </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
